import { render } from "./ProjectSmetaCompareNew.vue?vue&type=template&id=2c42c592&scoped=true"
import script from "./ProjectSmetaCompareNew.vue?vue&type=script&lang=js"
export * from "./ProjectSmetaCompareNew.vue?vue&type=script&lang=js"

import "./ProjectSmetaCompareNew.vue?vue&type=style&index=0&id=2c42c592&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c42c592"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QSpinner,QToggle,QTr,QTh,QTd});
